import React from 'react';
import { useTranslation } from 'react-i18next';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome/index';

const LoadingPage = ({ type, onClose }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="loadingSpinner">
        <FontAwesomeIcon icon={faSpinner} color="white" spin> </FontAwesomeIcon>
        <div className="loading-container">
          <span className="loading-text">{t(`${type}IsLoading`)}</span>
          <span >{t('pleaseWait')}</span>
          <span className="loading-close" onClick={onClose}>{t('button.close')}</span>
        </div>
      </div>
    </>
  );
};

export default LoadingPage;